import Utils from './utils.js';

const utils = Utils;
const BREAK = '__BREAK__';

export default class Query extends Array {
  constructor(selector, args) {
    super();

    args = args || {};
    args.context = args.context || this;

    this.context = args.context;

    this.add(false, selector);
  }

  // private -----------------------------------------------------------------
  _create(items) {
    if (items === undefined) {
      items = this;
    }

    if (utils.is.fn(items)) {
      var callback = items;
      var items = this;
      var elements = [];

      utils.each(items, function (el, i) {
        var response = callback.call(this, el, i);
        if (response instanceof Array) {
          elements = elements.concat(response);
        } else if (response) {
          elements.push(response);
        }
      });

      items = elements;
    } else {
      items = utils.toArray(items);
    }

    return new Query(items, { context: this.context });
  }

  _walk(el, key, callback) {
    while (el && el !== document) {
      if (el.nodeType === 1 && utils.is.fn(callback)) {
        var response = callback.apply(this, [el]);
        if (response === BREAK) {
          break;
        }
      }
      el = el[key];
    }
  }

  _is(el, selector, isStrict) {
    if (selector instanceof Query) {
      selector = selector[0];
    }
    return (!selector && !isStrict) || (selector && utils.dom.is(el, selector)) ? el : undefined;
  }

  _set(key, value, callback) {
    var set = utils.toSet(key, value);

    if (set) {
      return this.each(function (el) {
        callback(el, set);
      });
    } else if (this[0] && key) {
      return callback(this[0], key);
    } else if (this[0]) {
      return callback(this[0]) || {};
    } else {
      return key !== undefined || value !== undefined ? undefined : {};
    }
  }

  _toFragment(els, isClone, list) {
    var frag = document.createDocumentFragment();
    var i = 0,
      l = els.length,
      el;

    for (; i < l; ++i) {
      el = isClone ? els[i].cloneNode(true) : els[i];
      frag.appendChild(el);

      if (list instanceof Array) {
        list.push(el);
      }
    }

    return frag;
  }

  _clone(selector, callback) {
    var source = utils.dom.getAll(selector);
    var self = this;
    var els;

    this.each(function (el, i, l) {
      els = self._toFragment(source, i !== l - 1);

      if (utils.is.str(callback)) {
        utils.dom.add(els, callback, el);
      } else {
        callback.apply(this, [el, els]);
      }
    });

    return this;
  }

  _cloneTo(selector, callback) {
    var targets = utils.dom.getAll(selector);
    var clones = [];
    var i = 0,
      l = targets.length,
      el,
      els;

    for (; i < l; ++i) {
      els = this._toFragment(this, i !== l - 1, clones);
      el = targets[i];

      if (utils.is.str(callback)) {
        utils.dom.add(els, callback, el);
      } else {
        callback.apply(this, [els, el]);
      }
    }

    return this._create(clones);
  }

  // loops -------------------------------------------------------------------
  each(args, callback) {
    if (utils.is.fn(args)) {
      callback = args;
      args = {};
    }
    if (!utils.is.fn(callback)) {
      return this;
    }
    this.map(args, callback);
    return this;
  }

  map(args, callback, onlyEl) {
    if (utils.is.fn(args)) {
      onlyEl = callback;
      callback = args;
      args = {};
    } else if (utils.is.bool(args)) {
      args = { query: args };
    }

    args.context = 'context' in args ? args.context : this.context || this;
    args.query = 'query' in args ? args.query : false;
    // args.context = 'context' in args ? args.context : (this.context || this);
    // args.query 	 = 'query' in args ? args.query : false;

    if (typeof callback !== 'function') {
      return [];
    }

    var r, q;
    var items = utils.each(this, { context: this }, function (el, i, a) {
      if (args.query) {
        q = utils.cache(el, 'query');

        // cache the query in the element, so we can reuse them
        if (!q) {
          q = new Query(el);
          utils.cache(el, 'query', q);
        }

        q.context = args.context;
        el = q;
      }

      if (!onlyEl || (onlyEl && utils.is.el(el))) {
        r = callback.apply(args.context, [el, i, a]);
        return r;
      }
    });

    return items;

    // if (utils.is.fn(args)){
    //     callback = args;
    // 	args 	 = {};
    // }else if (utils.is.bool(args)){
    //     args 	 = {'query':args};
    // }

    // args.context = 'context' in args ? args.context : (this.context || this);
    // args.query 	 = 'query' in args ? args.query : false;

    // if (typeof callback !== 'function'){
    // 	return [];
    // }

    // var items = [];
    // var i=0, l=this.length, el, r, q;
    // for (; i<l; ++i){
    // 	el = this[i];

    //     // turn the HTMLElement into a Query item
    // 	if (args.query){
    //         q = utils.cache(el, 'query');

    //         // cache the query in the element, so we can reuse them
    //         if (!q){
    //             q = new Query(el);
    //             utils.cache(el, 'query', q);
    //         }

    //         q.context = args.context;
    //         el        = q;
    // 	}

    //     r = callback.apply(args.context, [el, i, this.length]);

    // 	items.push(r);
    // }

    // return items;
  }

  // fetch -------------------------------------------------------------------
  add(isNewQuery, selector) {
    if (selector === undefined) {
      selector = isNewQuery;
      isNewQuery = true;
    }
    if (isNewQuery === undefined) {
      isNewQuery = true;
    }

    var els = utils.dom.getAll(selector);

    if (isNewQuery) {
      els = this.get().concat(els);
      els = this._create(els);
      return els;
    } else {
      var i = 0,
        l = els.length,
        el;
      for (; i < l; ++i) {
        el = els[i];
        if (el && !~this.indexOf(el)) {
          this.push(el);
        }
      }
    }

    return this;
  }

  get(search) {
    if (search === undefined) {
      return utils.toArray(this);
      // get a value of the elements
    } else if (utils.is.fn(search)) {
      var values = [];
      this.each(function (el) {
        var value = search(el);
        values.push(value);
      });
      return values;
    } else {
      return this[search];
    }
  }

  find(isSelf, selector) {
    if (selector === undefined) {
      selector = isSelf;
      isSelf = false;
    }

    return this._create(function (el) {
      var els = utils.dom.getAll(selector, { context: el });

      if (isSelf && this._is(el, selector)) {
        els.unshift(el);
      }

      return els;
    });
  }

  filter(selector) {
    return this._create(function (el) {
      return this._is(el, selector);
    });
  }

  children(includeText, selector) {
    if (!utils.is.bool(includeText)) {
      selector = includeText;
      includeText = false;
    }

    return this._create(function (el) {
      var children = utils.dom.children(el, { text: includeText });
      return utils.each(children, { filter: true, context: this }, function (c) {
        return this._is(c, selector);
      });
    });
  }

  parent(selector) {
    return this._create(function (el) {
      return this._is(el.parentNode, selector);
    });
  }

  parents(selector, untilSelector) {
    return this._create(function (el) {
      var parents = [];

      this._walk(el.parentNode, 'parentNode', function (parent) {
        if (this._is(parent, selector)) {
          parents.push(parent);
        }
        if (this._is(parent, untilSelector, true)) {
          return BREAK;
        }
      });

      return parents;
    });
  }

  closest(selector, untilSelector) {
    var until = utils.dom.get(untilSelector);
    return this._create(function (el) {
      return utils.dom.closest(el, selector, until);
    });
  }

  next(selector) {
    return this._create(function (el) {
      return this._is(el.nextElementSibling, selector);
    });
  }

  prev(selector) {
    return this._create(function (el) {
      return this._is(el.previousElementSibling, selector);
    });
  }

  not(selector) {
    return this._create(function (el) {
      return this._is(el, selector) ? false : el;
    });
  }

  eq(index) {
    if (index === 'first') {
      index = 0;
    } else if (index === 'last') {
      index = this.length - 1;
    }
    return this._create([this[index]]);
  }

  first(count) {
    if (count) {
      return this._create(this.slice(0, count));
    } else {
      return this.eq('first');
    }
  }

  last(count) {
    if (count) {
      return this._create(this.slice(count * -1));
    } else {
      return this.eq('last');
    }
  }

  // insert/remove -----------------------------------------------------------
  remove() {
    return this.each(function (el) {
      utils.dom.remove(el);
    });
  }

  append(selector) {
    return this._clone(selector, 'append');
  }

  appendTo(selector) {
    return this._cloneTo(selector, 'append');
  }

  prepend(selector) {
    return this._clone(selector, 'prepend');
  }

  prependTo(selector) {
    return this._cloneTo(selector, 'prepend');
  }

  before(selector) {
    return this._clone(selector, 'before');
  }

  insertBefore(selector) {
    return this._cloneTo(selector, 'before');
  }

  after(selector) {
    return this._clone(selector, 'after');
  }

  insertAfter(selector) {
    return this._cloneTo(selector, 'after');
  }

  wrap(selector) {
    return this._clone(selector, 'wrap');
  }

  clone(withEventsCache) {
    return this._create(function (el) {
      return utils.dom.clone(el, withEventsCache);
    });
  }

  // validation --------------------------------------------------------------
  is(selector, allValid) {
    var self = this;
    var isValid = null;

    this.each(function (el) {
      var valid = self._is(el, selector);
      if (allValid && !valid) {
        isValid = false;
      } else if (isValid === null && valid) {
        isValid = true;
      }
    });

    return !!isValid;
  }

  contains(selector, allValid) {
    var isValid = true;

    this.each(this, function (el) {
      var children = utils.dom.getAll(selector, { context: el });
      var found = 0;

      for (var i in children) {
        var child = children[i];
        if (utils.dom.contains(el, child)) {
          found++;
        }
      }

      if (!found || (allValid && found < children.length)) {
        isValid = false;
      }
    });

    return !!isValid;
  }

  visible(allValid) {
    var isValid = null;

    this.each(function (el) {
      var valid = utils.dom.isVisible(el);

      if (allValid && !valid) {
        isValid = false;
      } else if (isValid === null && valid) {
        isValid = true;
      }
    });

    return !!isValid;
  }

  // props -------------------------------------------------------------------
  tag() {
    if (this[0]) {
      return this[0].tagName.toLowerCase();
    } else {
      return null;
    }
  }

  attrs(key, value) {
    return this._set(key, value, utils.dom.attrs);
  }

  props(key, value) {
    return this._set(key, value, utils.dom.props);
  }

  data(key, value) {
    return this._set(key, value, utils.dom.data);
  }

  cache(key, value) {
    return this._set(key, value, utils.cache);
  }

  style(key, value) {
    return this._set(key, value, utils.dom.style);
  }

  hide() {
    return this.style('display', 'none');
  }

  show() {
    return this.style('display', '');
  }

  html(html, data) {
    if (arguments.length) {
      if (utils.is.str(html)) {
        html = utils.string.replace(html, data);
      } else if (html instanceof Query) {
        html = html.get();
      }

      return this.each(function (el) {
        utils.dom.html(el, html);
      });
    } else if (this[0]) {
      return utils.dom.html(this[0]);
    } else {
      return '';
    }
  }

  text(text, data) {
    if (arguments.length) {
      text = utils.is.str(html) ? utils.string.replace(text, data) : text;

      this.each(function (el) {
        el.innerText = text;
      });
    } else if (this[0]) {
      return this[0].innerText;
    } else {
      return '';
    }
  }

  val(value, data) {
    if (arguments.length) {
      return this.each(function (el) {
        utils.dom.val(el, value, data);
      });
    } else if (this[0]) {
      return utils.dom.val(this[0]);
    } else {
      return undefined;
    }
  }

  values(values) {
    if (arguments.length) {
      return this.each(function (el) {
        utils.dom.values(el, values);
      });
    } else if (this[0]) {
      return utils.dom.values(this[0]);
    } else {
      return undefined;
    }
  }

  index(parentSelector) {
    return this[0] ? utils.dom.index(this[0], parentSelector) : -1;
  }

  scroll() {
    if (this[0]) {
      return utils.dom.scroll(this[0]);
    } else {
      return undefined;
    }
  }

  // classnames --------------------------------------------------------------
  classnames(classnames) {
    return this.each(function (el) {
      utils.dom.classnames(el, classnames);
    });
  }

  hasClass(classname) {
    var isFound = false;
    var classnames;

    this.each(function (el) {
      classnames = utils.dom.classnames(el);

      if (~classnames.indexOf(classname)) {
        isFound = true;
      }
    });

    return isFound;
  }

  addClass(classnames, duration) {
    return this.each(function (el) {
      utils.dom.classnames.add(el, classnames, null, duration);
    });
  }

  removeClass(classnames) {
    return this.each(function (el) {
      utils.dom.classnames.remove(el, classnames);
    });
  }

  toggleClass(classnames) {
    return this.each(function (el) {
      utils.dom.classnames.toggle(el, classnames);
    });
  }

  // dimensions --------------------------------------------------------------
  bounds(args) {
    return utils.dom.bounds(this[0], args);
  }

  width() {
    return this.bounds().width;
  }

  height() {
    return this.bounds().height;
  }

  // events ------------------------------------------------------------------
  on(name, args) {
    args = (utils.is.fn(args) ? { callback: args } : args) || {};
    args.context = args.context || this.context;

    return this.each(function (el) {
      utils.dom.events.add(el, name, args);
    });
  }

  off(name, args) {
    args = (utils.is.fn(args) ? { callback: args } : args) || {};
    args.context = args.context || this.context;

    return this.each(function (el) {
      utils.dom.addevents.remove(el, name, args);
    });
  }

  trigger(name, args) {
    return this.each(function (el) {
      utils.dom.events.trigger(el, name, args);
    });
  }

  // http --------------------------------------------------------------------
  load(url, args) {
    if (utils.is.fn(args)) {
      args.callback = { callback: args };
    }

    args = args || {};
    args.context = args.context || this.context;
    args.position = args.position || null; // [append, prepend, before, after, ..., null]

    var self = this;
    var oCallback = args.callback;

    args.callback = function (response, success, e) {
      self.each(function (el) {
        var nodes = self._create([]); // empty Query
        var html = response.html || response;

        if (success && utils.is.str(html)) {
          nodes.add(false, html);

          if (args.position) {
            utils.dom.add(nodes, args.position, el);
          } else {
            utils.dom.html(el, nodes);
          }
        }

        utils.apply(oCallback, [nodes, response, success, e], args.context);
      });
    };

    utils.media.http(url, args);

    return this;
  }

  // aliases -----------------------------------------------------------------
  css() {
    return this.style.apply(this, arguments);
  }

  attr() {
    return this.attrs.apply(this, arguments);
  }

  prop() {
    return this.props.apply(this, arguments);
  }

  removeAttr(name) {
    return this.attrs(name, '');
  }
}

window.Query = Query;
